/*
 * � 2020 Microsoft. All rights reserved.
 */

define('CardUI/WinAnimators/BaseWinAnimator',['Arkadium/GameEngine/Scenes/Nodes/SpriteNode'], function (SpriteNode) {
    "use strict";

    var BaseWinAnimator = function (supplyView) {
        this.initBaseWinAnimator(supplyView);
    };

    BaseWinAnimator.prototype.initBaseWinAnimator = function (supplyView) {
        this._supplyView = supplyView;
        this._animationSide = this.SupplyView.CardSupply.GameName.toLowerCase() == "spider" ? 1 : -1;
        this._endAnimationCallback = null;
        this._hasUserClicked = false;
        this._hasAnimationStarted = false;
        this._animationContainer = null; /* SceneNode */
        this._background = null;
    };

    Object.defineProperties(BaseWinAnimator.prototype, {
        SupplyView: {
            get: function () {
                return this._supplyView;
            }
        },
        AnimationContainer: {
            get: function () {
                return this._animationContainer;
            }
        },
        AnimationSide: {
            get: function () {
                return this._animationSide;
            },
            set: function (value) {
                this._animationSide = value;
            }
        }
    });

    BaseWinAnimator.prototype.BeginAnimation = function (/* Action */ endAnimationCallback, /* Card */ lastCardDropped, /* Pile */ lastPileDroppedOnto, /* bool */ dragging) {
        this._endAnimationCallback = endAnimationCallback;
        this._hasUserClicked = false;
        this._hasAnimationStarted = true;

        // TODO
        //Window.Current.SizeChanged += OnSizeChanged;
        //EngineManagers.Input.PointDown += StopAnimationPointEvent;
        //EngineManagers.Input.KeyDown += StopAnimationKeyEvent;

        this.SupplyView.GameInputInterpreter.ClearHighlight();
        this.UpdateEndingAnimationHandler = this.UpdateEndingAnimation.bind(this);
        this.SupplyView.Updated.add(this.UpdateEndingAnimationHandler);
        if (this._background == null)
        {
            this._background = new SpriteNode();
        }
        if (this._animationContainer == null)
        {
            this._animationContainer = new SpriteNode();
        }

        this.SupplyView.Parent.setEndGameAnimator(this._animationContainer, this._background, this.FinishEndingAnimation.bind(this));
    };


    BaseWinAnimator.prototype.UpdateEndingAnimation = function (/*object*/ o, /*EventArgs*/ time)
    {

    };

    BaseWinAnimator.prototype.PauseEndingAnimation = function ()
    {

    };

    BaseWinAnimator.prototype.FinishEndingAnimation = function ()
    {
        /*
         TODO
         Window.Current.SizeChanged -= OnSizeChanged;
         EngineManagers.Input.PointDown -= StopAnimationPointEvent;
         EngineManagers.Input.KeyDown -= StopAnimationKeyEvent;
         */

        this.SupplyView.Updated.remove(this.UpdateEndingAnimationHandler);

        if (this._animationContainer != null && this._animationContainer.Parent != null)
        {
            this._animationContainer.Parent.removeEndGameAnimator();
            this._animationContainer = null;
            this._background = null;
        }
        this._hasUserClicked = false;
        this._hasAnimationStarted = false;
        if (this._endAnimationCallback != null)
        {
            this._endAnimationCallback();
        }
    };

    BaseWinAnimator.prototype.EndAnimation = function ()
    {
        this.FinishEndingAnimation();
    };


    return BaseWinAnimator;

});
